var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/hooks/useLibreDataShare.tsx";
import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { createNewDataShareService, stopDataShareService } from 'Services/libre_api';
const useLibrePartner = () => {
  const createNewDataShare = useCallback(async () => {
    return createNewDataShareService();
  }, []);
  const stopDataShare = useCallback(async () => {
    return stopDataShareService();
  }, []);
  const showStopSharingModal = useCallback((onRemoveClick, onCancelClick) => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        buttonLayout: 'column',
        details: /*#__PURE__*/React.createElement(Stack, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28,
            columnNumber: 13
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.strong",
          fontSize: "$bodyBase.strong",
          testID: "stopSharingEarly.title",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29,
            columnNumber: 15
          }
        }, i18n.t('Connections.modals.stopSharingEarly.title')), /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.default",
          fontSize: "$bodyBase.default",
          testID: "stopSharingEarly.body",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 38,
            columnNumber: 15
          }
        }, i18n.t('Connections.modals.stopSharingEarly.body'))),
        primaryAction: {
          label: i18n.t('Connections.modals.stopSharingEarly.linkText'),
          destructive: true,
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onRemoveClick();
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onCancelClick();
          }
        },
        testID: 'stopSharingEarly'
      }
    });
  }, []);
  return {
    showStopSharingModal,
    stopDataShare,
    createNewDataShare
  };
};
export default useLibrePartner;